import { ChartTypeConfig } from './ChartTypeConfig';
import { SeriesType } from '../utils/SeriesType';
import { BasicChart, SeriesOption } from '../utils/models';
import { ChartConfig } from './ChartConfig';

export class RadarChartConfig extends ChartConfig implements ChartTypeConfig {
  getConfig(categories: string[], data: SeriesOption[], colors: string[] = this.defaultColors): Partial<BasicChart> {
    const maxValues = this.calculateMaxPerIndicator(data, categories.length);
    const indicators = categories.map((category, idx) => ({
      name: category.length > 60 ? category.slice(0, 60) + '...' : category,
      // max: this.roundUpMax(maxValues[idx])
    }));

    const seriesColors = colors;

    const radarSeriesData = data.map((seriesData, idx) => {
      const color = seriesData[idx]?.color ?? seriesColors[idx % seriesColors.length]
      return {
        value: seriesData.data?.map(x => x?.value ?? x) ?? [],
        name: seriesData.name ?? `Series ${idx + 1}`,
        itemStyle: {
          color
        },
        symbolSize: 2,
        areaStyle: {
          color: this.hexToRgba(color, 0.2) // 20% opacity background
        },
        label: {
          show: true,
          formatter: function (params) {
            return params.value + '%';
          }
        }


      }
    });

    const series = [
      {
        name: 'Radar Series',
        type: SeriesType.Radar,
        // symbol: 'none',
        data: radarSeriesData,
        areaStyle: {}, // optional,
      }
    ];
    const legendData = radarSeriesData.map(item => item.name);

    return {
      alignTicks: false,
      radar: {
        indicator: indicators,
        shape: 'polygon',
        splitNumber: 5,
        center: ['50%', '55%'],
        axisNameGap: 12,
        radius: '58%',
        splitLine: {
          lineStyle: {
            color: ['#ccc'],
            type: 'dashed'
          }
        },
        splitArea: { show: false },
        axisLine: { show: false },
        axisName: {
          show: true,
          fontSize: 11,
          color: '#333',
          formatter: function (name) {
            const maxLen = 15;
            const words = name.split(' ');
            let lines: any = [];
            let currentLine = '';

            words.forEach(word => {
              if ((currentLine + word).length <= maxLen) {
                currentLine += (currentLine ? ' ' : '') + word;
              } else {
                lines.push(currentLine);
                currentLine = word; // start new line with this word
              }
            });

            if (currentLine) lines.push(currentLine);

            return lines.join('\n');
          }
        }

      },
      legend: {
        show: true,
        data: legendData,
        bottom: 0,
        left: 'center'
      },
      series,
    };
  }

  private hexToRgba(hex: string, alpha: number): string {
    const bigint = parseInt(hex.replace('#', ''), 16);
    const r = (bigint >> 16) & 255;
    const g = (bigint >> 8) & 255;
    const b = bigint & 255;
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  }
  private roundUpMax(value: number): number {
    if (value <= 10) return 12;
    if (value <= 20) return 23;
    if (value <= 50) return 53;
    if (value <= 100) return 105;
    return Math.ceil(value / 50) * 50; // round to next 50
  }

  private calculateMaxPerIndicator(data: SeriesOption[], indicatorCount: number): number[] {
    const maxValues = Array(indicatorCount).fill(0);

    data.forEach(series => {
      const values = series.data ?? [];
      values.forEach((val, idx) => {
        if (val != null) {
          maxValues[idx] = Math.max(maxValues[idx], val?.value ?? val);
        }
      });
    });

    return maxValues;
  }
}
